import type { Locale } from 'date-fns';
import {
  ru, enUS, ptBR, es,
} from 'date-fns/locale';

/**
 * Единый источник date-fns-локалей, завязанный на build-флаги локалей.
 *
 * Каждая локаль под своим `__LOCALE_*__`, поэтому для отключённых локалей date-fns-данные
 * (месяцы, formatDistance и т.п.) вырезаются из бандла (date-fns помечен `sideEffects: false`,
 * так что неиспользуемые именованные импорты tree-shake-аются). Без этого ru/pt/es date-fns
 * попадали в бандл при любом наборе локалей.
 *
 * Ключи — рантайм-коды i18next (`en`/`ru`/`pt-BR`/`es`) и их alias-формы; fallback — `enUS`.
 */
const DATE_FNS_LOCALES: Record<string, Locale> = {
  ...(__LOCALE_EN__ ? { en: enUS, 'en-US': enUS } : {}),
  ...(__LOCALE_RU__ ? { ru } : {}),
  ...(__LOCALE_PTBR__ ? { 'pt-BR': ptBR, ptBr: ptBR } : {}),
  ...(__LOCALE_ESES__ ? { es, esEs: es, 'es-ES': es } : {}),
};

export const getDateFnsLocale = (lang?: string): Locale => DATE_FNS_LOCALES[lang ?? ''] ?? enUS;
